import {Box, Typography, useTheme} from "@mui/material";
import styles from "./Window.module.css";

const Window = ({title, topRightButtons, children}) => {
  const theme = useTheme();

  return (
    <Box className={styles.container} style={{"--backgroundColor": theme.palette.windowScreen.background}}>
      <Box
        className={styles.header}
        style={{
          "--headerBackgroundColor": theme.palette.windowScreen.headerBackground
        }}
      >
        <Typography variant="h3" fontWeight="bold" color={theme.palette.windowScreen.title}>
          {title}
        </Typography>

        {topRightButtons && <Box className={styles.topRightButtons}>{topRightButtons}</Box>}
      </Box>

      <Box className={styles.content}>{children}</Box>
    </Box>
  );
};

export default Window;
